import { sendCPCLog } from '../../../utils/common';
import FloatingBanner from '../../extra/FloatingBanner';
import Renderer from './Renderer';

/**
 * @export
 * @class DealContents
 * 상품설명 | 리뷰컨텐츠 | 딜컨텐츠
 *  - 여행 테스트딜: 671958342
 */
export default class DealContents {
  constructor() {
    this.welWrapper = $("#_wrapDealContents");
    this.nDetailImageSplitIdx = 0;
    this.oRenderer = new Renderer();
    this.init();
  }

  init() {
    this.render();
    this.renderViewMoreBtn();
    this.setSizeMultiColumn("width");
    this.setSizeMultiColumn("height");
    this.replaceHtmlAfterRender();
    this.resizeYoutubeBanner();
    this.setEvent();
    // CPC 연동
    this.sendImpression();
    this.setImageLazyLoad();
    this.setSummaryOptionHeight();
    if (TMON.util.getHashJSON().scene === 'scene-optiondetail') {
      this.initOptionDetail();
    }
  }

  update = (sStorageKey) => {
    switch (sStorageKey) {
      case "selectedActionIndex":
        this.oRenderer.nOptionDealIndex = TMON.oApp.htStorage.selectedActionIndex;
        break;
      case "setSummaryOptionHeight":
        this.setSummaryOptionHeight();
        break;
      case "splitContent":
        // selectedList를 가져온 후 다시 값 세팅
        this.oRenderer.selectedList =
          TMON.oApp.htStorage.optionInfo &&
          TMON.oApp.htStorage.optionInfo.selectedList
            ? TMON.oApp.htStorage.optionInfo.selectedList
            : [];
        this.oRenderer.nOptionDealIndex =
          this.oRenderer.selectedList.length > 0 ? this.oRenderer.selectedList[0].idx : 0;

        this.oRenderer.updateHTML();
        this.setImageLazyLoad();
        this.setSummaryOptionHeight();
        this.initOptionDetail();
        break;
      case "scene":
        if (!TMON.util.getHashJSON().scene && TMON.oApp.sPlatform !== "PW") {
          // 상세 팝업 띄울 때 상품 상세보기 이미지가 한꺼번에 불러와지는 이슈 해결
          $('#_wrapDealContents').css('display', 'block');
        }
        if (!(TMON.util.getHashJSON().scene === 'scene-optiondetail')) {
          TMON.oApp.setStorage("setSummaryOptionHeight", true);
        }
        break;
      default:
        break;
    }
  };

  render() {
    /* UI 노출 여부에 의해 html 생성 */
    const sHTML = this.oRenderer.initHTML();

    /**
     * scoped polyfill(deals.common.js에 포함)
     * style 태그에 scoped 속성을 넣어 스타일 적용 영역을 제한
     */
    const container = document.createElement('div');
    container.innerHTML = sHTML;
    const styleList = [...container.querySelectorAll('style')];
    styleList.forEach((style) => {
      style.setAttribute("scoped", true);
    });
    this.welWrapper.html(container.innerHTML);

    if (
      this.oRenderer.contentType === "SUMMARY" &&
      !this.oRenderer.bOptionDeal &&
      !TMON.util.getHashJSON().scene
    ) {
      this.setSummaryOptionHeight();
      $(".tmde-opt-thmb img").on("load", (e) => {
        this.setTmdeThumbnailVerticalAlign($(e.currentTarget));
      });
    }
  }

  initOptionDetail() {
    if (
      (TMON.oApp.htStorage.htStaticData.htDealContentInfo.contentType ===
        "SUMMARY" ||
        TMON.oApp.htStorage.htStaticData.htDealContentInfo.contentType === 
          "OPTION_VIEW_DETAIL") &&
      !this.oRenderer.bOptionDeal // 옵션 진입딜은 selectedActionIndex 값이 초기화 된 후에 렌더링 한다.
    ) {
      this.setDetailImageLazyLoad();
    }
  }

  renderViewMoreBtn() {
    if ($('#viewAllBtn').length) return;
    
    const welDescription = $('#description');
    const nMinHeight = TMON.bMobile ? 1000 : 1500;

    let bRenderMoreBtn = true;
    let bRenderDealAllBtn = false;
    if (this.oRenderer.contentType === 'IMAGE' && welDescription.height() < nMinHeight) {
      bRenderMoreBtn = false;
    }
    if (this.oRenderer.contentType !== 'IMAGE' && this.oRenderer.bOptionDeal) {
      bRenderDealAllBtn = true;
    }

    let sHtml = '';
    // 전체 옵션 모두 보기 버튼만
    if (bRenderDealAllBtn && !bRenderMoreBtn) {
      sHtml = this.oRenderer.makeAllButton();
    } 
    // 전체 옵션 모두 보기 + 더보기 버튼
    else if (bRenderDealAllBtn && bRenderMoreBtn) {
      sHtml = `<div id="viewAllBtn" class="btn_view_wrap open">
          ${this.oRenderer.makeAllButton()}
          <button type="button" class="btn_view">상세정보 더보기</button>
        </div>`;
    } 
    // 더보기 버튼만
    else if (!bRenderDealAllBtn && bRenderMoreBtn) {
      sHtml = `<div id="viewAllBtn" class="btn_view_all">
          <button type="button" class="btn_view">상세정보 더보기</button>
        </div>
      `
    }
    
    const welTarget = TMON.bMobile ? welDescription.find('.separate') : welDescription;
    welTarget.addClass('open');
    welTarget.after(sHtml);
    this.welDealAllBtn = welDescription.find('.btn_deal_all').eq(0);
    this.welDealAllBtn.hide();

    $("#viewAllBtn").on(
      "click", "button", $.proxy(this.onClickViewAllButton, this)
    )    
  }

  setSummaryOptionHeight() {
    // Summary Content 가 없으면 수행하지 않음
    if (this.oRenderer.contentType !== 'SUMMARY') return;
    if (this.oRenderer.bOptionDeal) return;
    if (TMON.util.getHashJSON().scene) return;

    // height 재정의
    for (let nRow = 1; this.oRenderer.nRows >= nRow; nRow += 1) {
      let nSubjectMaxHeight = 0;
      let nDetailMaxHeight = 0;
      let nPriceMaxHeight = 0;

      const itemList = [...document.querySelectorAll(`.tmde-template-colmn[data-row="${nRow}"]`)];
      itemList.forEach(item => {
        const subject = item.querySelector('.tmde-opt-subject');
        if (subject) {
          nSubjectMaxHeight = Math.max(nSubjectMaxHeight, subject.clientHeight);
        }

        const detail = item.querySelector('.tmde-opt-detail');
        if (detail) {
          nDetailMaxHeight = Math.max(nDetailMaxHeight, detail.clientHeight);
        }

        let priceHeight = 0;
        const optPrice = item.querySelector('.tmde-opt-price');
        const originPrice = item.querySelector('.tmde-origin-price');
        if (optPrice) priceHeight += optPrice.clientHeight;
        if (originPrice) {
          priceHeight += originPrice.clientHeight;
          priceHeight += +getComputedStyle(originPrice).bottom.replace('px', '');
        }
        nPriceMaxHeight = Math.max(nPriceMaxHeight, priceHeight);
      });

      itemList.forEach(item => {
        const subject = item.querySelector('.tmde-opt-subject');
        if (subject) {
          subject.style.height = `${nSubjectMaxHeight}px`;
        }

        const detail = item.querySelector('.tmde-opt-detail');
        if (detail) {
          detail.style.height = `${nDetailMaxHeight}px`;
        }
      });
    }
  }

  setTmdeThumbnailVerticalAlign = (welThumb) => {
    if (this.oRenderer.summaryCols === "column1") {
      const nItemPaddingTop = parseInt(
        welThumb.closest(".tmde-template-colmn a").css("paddingTop"),
        10
      );
      const nItemButtonHeight =
        welThumb
          .closest(".tmde-template-colmn")
          .find(".item_button")
          .innerHeight() || 0;
      const nItemHeight =
        welThumb.closest(".tmde-template-colmn").innerHeight() -
        nItemButtonHeight -
        nItemPaddingTop;
      const nThumbHeight = welThumb.closest(".tmde-opt-thmb").innerHeight();
      let nMarginTop = 0; // nMarginTop 은 썸네일에 부여할 marginTop 값이다.
      nMarginTop = nItemPaddingTop * -1; // 우선 썸네일을 감싼 앵커의 상단 padding 만큼 당겨준다.
      nMarginTop += (nItemHeight - nThumbHeight) / 2; // 중앙 정렬
      nMarginTop += 1; // border 보정
      if (nItemHeight > nThumbHeight) {
        welThumb.closest(".tmde-opt-thmb").css("marginTop", nMarginTop);
      }
    }
  };

  /**
   * setSizeMulticolumn
   * 멀티컬럼 딜의 width 와 height 를 설정한다.
   * @param {*} sType : weidth / height
   */
  setSizeMultiColumn(sType) {
    if (
      this.oRenderer.columnSize !== "M" ||
      TMON.oApp.htViews.view !== "view-default" ||
      TMON.oApp.htViews.scene !== "scene-default" ||
      TMON.oApp.sPlatform === "PW"
    ) {
      return;
    }
    const welMultiList = $(".colmM");
    const welMultiColumn = welMultiList.closest(".review_opt");
    const nScaleRatio = welMultiColumn.width() / 770;
    if (sType === "width") {
      welMultiList.css({
        "transform-origin-x": 0,
        "transform-origin-y": 0,
        "-webkit-transform-origin-x": 0,
        "-webkit-transform-origin-y": 0,
        transform: `scale(${nScaleRatio}, ${nScaleRatio})`,
        "-webkit-transform": `scale(${nScaleRatio}, ${nScaleRatio})`,
      });
    }
    if (sType === "height") {
      const nTargetHeight = welMultiList.height() * nScaleRatio;
      const nWrapHeight = welMultiColumn.attr("data-height");
      if (nWrapHeight && nWrapHeight === nTargetHeight) {
        return;
      }
      const nViewHeight = parseInt(welMultiList.height() * nScaleRatio, 10);
      if (welMultiColumn.height() === nViewHeight) {
        return;
      }
      welMultiColumn.attr("data-height", nTargetHeight);
      welMultiColumn.css({
        overflow: "hidden",
        height: nViewHeight,
      });
    }
  }

  replaceHtmlAfterRender() {
    // table, th, td에 html 속성으로 width 가 내려오는것을 리셋
    $(".review table, .review table th, .review table td").css({
      width: "auto",
      "max-width": "100%",
      "padding-left": "4px",
      "padding-right": "4px",
    });
    $(".review table").css({ width: "100%" });

    // view_mode 가 app일 때 href 속성 내에 sAppQuery 붙임
    if (TMON.view_mode === "app") {
      const aHrefRegex = /<a(.*?)href="(.*?)"/gim;
      $(".review ._replace:not(._complete)").each(function fn() {
        const replacedHtmlText = $(this)
          .html()
          .replace(aHrefRegex, (match, p1, p2) => {
            let url = p2;
            let bHasRelativeDealUrl = false;
            let datarole = "showview";
            url = url.replace("http://www.tmon.co.kr/deal/", "/deals/");
            url = url.replace("https://www.tmon.co.kr/deal/", "/deals/");
            url = url.replace(
              "http://m.tmon.co.kr/deal/detailDaily/",
              "/deals/"
            );
            url = url.replace(
              "https://m.tmon.co.kr/deal/detailDaily/",
              "/deals/"
            );
            url = url.replace(
              "http://mobile.tmon.co.kr/deal/detailDaily/",
              "/deals/"
            );
            url = url.replace("http://mobile.tmon.co.kr/deals/", "/deals/");
            if (
              url.substring(0, 7) === "/deals/" ||
              url.substring(0, 6) === "/deal/"
            ) {
              bHasRelativeDealUrl = true;
            }
            if (url.length !== p2.length || bHasRelativeDealUrl) {
              datarole = "dealsurl";
            }
            return `<a${p1} data-role=${datarole} href="${TMON.util.aup(
              url,
              TMON.sAppQuery
            )}"`;
          });

        $(this)
          .html(replacedHtmlText)
          .addClass("_complete");
      });
    }
  }

  setEvent() {
    this.welWrapper.on("click", ".item_button a", (e) => {
      this.onClickAddtionalButton(e);
    });
    this.welWrapper.on("click", ".item_button button", (e) => {
      this.onClickAddtionalButton(e);
    });
    this.welWrapper.on("click", "[data-role=openOptionDeal]", (e) => {
      this.onClickOpenOptionDeal(e);
    });
    
    // 앱에서 링크 이동 eventListener 등록
    if (TMON.view_mode === "app") {
      $("#description").on(
        "click",
        "a[data-role=showview]",
        $.proxy(this.clickShowViewOnApp, this)
      );
      $("#description").on(
        "click",
        "a[data-role=dealsurl]",
        $.proxy(this.clickDealsUrlOnApp, this)
      );
    }
  }

  clearEvent() {
    this.welWrapper.off("click", ".item_button a");
    this.welWrapper.off("click", ".item_button button");
    this.welWrapper.off("click", "[data-role=openOptionDeal]");

    if (TMON.view_mode === "app") {
      $("#description").off("click", "a[data-role=showview]");
      $("#description").off("click", "a[data-role=dealsurl]");
    }
  }

  onScroll() {
    this.setSizeMultiColumn("height");
  }

  onResize() {
    this.setSizeMultiColumn("width");
    this.setSizeMultiColumn("height");
  }

  onClickOpenOptionDeal(e) {
    e.preventDefault();
    const nOrderNo = $(e.currentTarget).attr("data-order");
    TMON.oApp.setStorage("openLayerInApplication", true);
    TMON.util.setHashJSON({ scene: "scene-optiondetail", order_no: nOrderNo });
  }

  onClickViewAllButton(e) {
    const welViewAllDiv = $('#viewAllBtn');
    const welViewAllBtn = welViewAllDiv.find('button');
    const welDescripDiv = $('#description');
    const welTarget = TMON.bMobile ? welDescripDiv.find('.separate') : welDescripDiv;

    if (TMON.oApp.htStorage.splitContent) {
      this.oRenderer.updateHTML();
      this.setImageLazyLoad();
      this.setSummaryOptionHeight();
      this.initOptionDetail();
    } else {
      this.fetchSplitContent();
    }
    
    // 상세정보 더보기 버튼 위치 저장
    if (this.nViewAllBtnHeight === undefined) {
      this.nViewAllBtnHeight = $('#description').height();
    }

    welViewAllDiv.toggleClass('open');
    welViewAllDiv.toggleClass('close');
    welTarget.toggleClass('open');
    welTarget.toggleClass('close');

    if (welViewAllDiv.hasClass('close')) {
      // 옵션딜에서 더보기 버튼 클릭시 '전체 옵션 모두 보기' 버튼을 상단에 노출 시킨다.
      if (this.welDealAllBtn) this.welDealAllBtn.show();
      welDescripDiv.css('max-height', 'none');
      TMON.sendLog(null, [
        e.currentTarget,
        e,
        { "tl:area": TMON.bMobile ? "DCUFD" : "PCUFD" },
      ]);
      welViewAllBtn.text('상세정보 접기');
      // 우측 플로팅 구매하기 영역 style 보정
      TMON.oApp.oPurchase.setPurchaseHeightOnPc();
    } else {
      if (this.welDealAllBtn) this.welDealAllBtn.hide();
      welDescripDiv.css('max-height', this.nViewAllBtnHeight);
      TMON.sendLog(null, [
        e.currentTarget,
        e,
        { "tl:area": TMON.bMobile ? "DCFD" : "PCFD" },
      ]);
      welViewAllBtn.text('상세정보 더보기');
      TMON.oApp.enableTab({ sTabId: 'description', bScrollToTab: true });
    }

    // [TM-12015] 상세정보 더보기 버튼 클릭시 5초 후 CPC 광고 상품 플로팅배너 노출
    if (TMON.oApp.sPlatform !== "PW" && !$('.floating-banner').length) {
      if (!TMON.oApp.htStorage.intergratedDeals) TMON.oApp.oApi.fetchApi("intergratedDeals")
      setTimeout(function() {
        new FloatingBanner();
      }, 5000);
    }
  }

  async fetchSplitContent() {
    if (
      (TMON.oApp.htStorage.htStaticData.htDealContentInfo.contentType ===
        "SUMMARY" ||
        TMON.oApp.htStorage.htStaticData.htDealContentInfo.contentType ===
          "OPTION_VIEW_DETAIL") &&
      !TMON.oApp.getStorage("splitContent")
    ) {
      // splitContent가 로드되는 동안은 더보기 버튼을 숨긴다.
      $('#viewAllBtn').hide();
      await TMON.oApp.oApi.fetchApi("splitContent");
      $('#viewAllBtn').show();
    }
  }

  /**
   * 기획전 url 패턴과 어떤 url이 일치하는지 검사하는 메서드를 생성한다.
   */
  createTestPlanUrl() {
    const aPlanUrl = [
      TMON.htLocal.htURL.www_planning || "",
      TMON.htLocal.htURL.www_planning_default || "",
    ];
    this.testPlanUrl = TMON.util.getUriTestFunction(aPlanUrl);
  }

  /**
   * data-role="showview" 인 앵커를 클릭했을 때 (앱에서)
   */
  clickShowViewOnApp(e) {
    const url = $(e.currentTarget).attr("href");

    if (!this.testPlanUrl) {
      this.createTestPlanUrl();
    }

    const aExecResult = this.testPlanUrl(url);
    if (aExecResult) {
      const sPlanId = aExecResult[1];
      TMON.app.callApp("event", "goIntegratedPlan", sPlanId);
      return false;
    }

    const { contentType } = TMON.oApp.htStorage.htStaticData.htDealContentInfo;
    if (contentType === 'IMAGE' && url.indexOf('cdn.ntruss.com') > -1) {
      TMON.app.callApp("webview", "showView", "TMON", url.split('?')[0], true, false);
    } else {
      TMON.app.callApp("webview", "showView", "TMON", url, true, false);
    }

    return false;
  }

  /**
   * data-role="dealsurl" 인 앵커를 클릭했을 때 (앱에서)
   */
  clickDealsUrlOnApp(e) {
    location.href = $(e.currentTarget).attr("href");
    return false;
  }

  setImageFail(el) {
    $(el).replaceWith(
      '<div class="no-image b"><div class="no-image-inner"></div></div>'
    );
  }

  setImageLazyLoad() {
    if (this.oLazy) {
      this.oLazy.destroy();
      delete this.oLazy;
    }

    const welUnloadImage = $("img.unload");
    for (let i = 0; i < welUnloadImage.length; i += 1) {
      if (!$(welUnloadImage[i]).attr("data-src")) {
        $(welUnloadImage[i]).remove();
      }
    }

    this.oLazy = $("img.unload").Lazy({
      scrollDirection: "vertical",
      effect: "fadeIn",
      chainable: false,
      visibleOnly: true,
      afterLoad: (el) => {
        $(el).removeClass("unload");
        this.renderViewMoreBtn();
        // 우측 플로팅 구매하기 영역 style 보정
        TMON.oApp.oPurchase.setPurchaseHeightOnPc();
      },
      // proxy 이미지 불러오기에 실패할 경우 원본 이미지 불러오기 위한 핸들러
      onError: (el) => {
        $(el).on('load', () => {
          $(el).removeClass("unload");
        })
        // 원본 이미지 불러오기에 실패할 경우 디폴트 이미지 보여주기 위한 핸들러
        $(el).on('error', () => { 
          $(el).hide();
          $(el).replaceWith(
            '<div class="no-image b"><div class="no-image-inner"></div></div>'
          );
        });

        const imageProxyUrl = new URL($(el).data('src'));
        const params = new URLSearchParams(imageProxyUrl.search);
        const originSrc = params.get("src");
        $(el).attr('src', originSrc);
      },
      bind: "event",
    });
    if ($(window).scrollTop > 0) {
      TMON.oApp.oUtil.scrollTop(this, $(window).scrollTop() + 1);
    }
  }

  setDetailImageLazyLoad() {
    const { contentType } = TMON.oApp.htStorage.htStaticData.htDealContentInfo;
    const io = new TMON.IntersectionObserver((entry, observer) => {
      if (entry.isIntersecting) {
        const { scene } = TMON.util.getHashJSON();
        if (scene === 'scene-optiondetail') return;
        this.nDetailImageSplitIdx += 50;
        this.oRenderer.updateDetailImageHTML(this.nDetailImageSplitIdx);
        observer.unobserve(entry.target);
        
        let contentsLength = 0;
        if (contentType === 'SUMMARY') {
          contentsLength = this.oRenderer.summaryContents ? this.oRenderer.summaryContents.length : 0;
        } else if (contentType === 'OPTION_VIEW_DETAIL') {
          contentsLength = this.oRenderer.imageList ? this.oRenderer.imageList.length : 0;
        }
        // append 할 상세 이미지가 남아있는 경우
        if (contentsLength > this.nDetailImageSplitIdx) {
          this.setDetailImageLazyLoad();
        } 
        // append 할 상세 이미지가 더이상 없는 경우
        else {
          const sHtml = this.oRenderer.makeMiscContent();
          this.welWrapper.append(sHtml);
        }
        this.setImageLazyLoad();
      }
    });

    if (this.nDetailImageSplitIdx === 0) {
      io.observe($('[data-role="op"]').last());
    } else if (contentType === 'SUMMARY') {
      io.observe($('.tmde-review-template').last());
    } else if (contentType === 'OPTION_VIEW_DETAIL') {
        io.observe($('.contents-options').last());
    }
  }

  onClickAddtionalButton = (e) => {
    const welButton = $(e.currentTarget);
    if (welButton.attr("data-role") === "옵션선택") {
      if (
        TMON.oApp.htStorage.optionInfo &&
        TMON.oApp.htStorage.optionInfo.isOnlyOption === false // 단일옵션딜이 아닐 경우에만 상품을 추가한다.
      ) {
        const { optionInfo, optionList } = TMON.oApp.htStorage;
        const { options, totalDepth } = optionInfo;
        const optionIdx = welButton.closest("[data-role=op]").index();
        const optionKey = totalDepth === 1 ? optionList.data[optionIdx].optionNo : options[0][optionIdx].key;
        TMON.oApp.setStorage("purchaseOption", {
          aKeyList: [optionKey],
          nCurrentDepth: 0,
          allDepthContainer: document.querySelector('div[data-role="prchSelector"]'),
          event: e,
        });
      }
      TMON.oApp.setStorage("purchaseDrawer", "openBuy");
    }
    TMON.oApp.oApi.fetchApi("statisticsClick", {
      areaCode: $(e.currentTarget).attr("data-tlarea"),
      linkOrder: $(e.currentTarget).attr("data-tlord"),
    });
  };

  /**
   * 광고를 통해서 진입한 경우 CPC 랜딩 이벤트 API 호출
   */
  sendImpression() {
    const queryParam = new URLSearchParams(location.search);
    const x = queryParam.get('x');
    if (x) {
      sendCPCLog([{ href: location }], 'LANDING');
    }
  }

  resizeYoutubeBanner = () => {
    /* Youtube 영상 비율 16:9 */
    if (document.querySelector(".vwa_video>iframe")) {
      const youtubeBannerInfo = document.querySelector(".vwa_video>iframe");
      const youtubeWidth = youtubeBannerInfo.clientWidth / 16;
      youtubeBannerInfo.setAttribute("height", youtubeWidth * 9);
    }
  };
}